import { Component, OnInit, EventEmitter, Output, Input, ChangeDetectorRef } from '@angular/core';


import { HelperService } from '../../../services/helper.service';
import { NotificationBuilder } from '../../../shared/notificationBuilder';
import { CampaignCouponModel, CampaignModel } from '../../../models/campaign.model';
import { NgxSmartModalComponent, NgxSmartModalService } from 'ngx-smart-modal';
import { StoreStatement, InvoiceSubItens } from '../../../models/profile.model';
import { DashboardService } from '../../dashboard.service';
import { AuthenticationService } from 'src/app/authentication/authentication.service';
import { Configuration } from 'src/app/app.constants';
import { JunoService } from 'src/app/services/juno.service';
declare var swal: any
declare var $: any

@Component({
    selector: 'admin-statementEdit',
    templateUrl: './admin-statementEdit.component.html',
})

export class AdminStatementEditComponent implements OnInit {
    @Input() invoiceId: CampaignModel
    @Output() answer = new EventEmitter();
    invoice: StoreStatement = null
    invoiceTypeEdit: string = null
    statementEdit: StoreStatement = null
    isAdmin: boolean;
    loading: boolean
    PlanItemViewerKey: string = null
    fixPaymentList: any = [
        {
            id: 1,
            value: 'Crédito'
        },
        {
            id: 2,
            value: 'Boleto'
        },
        {
            id: 6,
            value: 'Pix'
        }
    ];

    constructor(private helperService: HelperService, public authenticationService: AuthenticationService, public changeDetection: ChangeDetectorRef, private junoService: JunoService, private dashboardService: DashboardService, private notificationBuilder: NotificationBuilder, public ngxSmartModalService: NgxSmartModalService) {
    }

    ngOnInit() { }

    ngAfterViewInit() {
        console.log('ngAfterViewChecked');
        this.ngxSmartModalService.getModal('invoiceModal').onDismiss.subscribe((modal: NgxSmartModalComponent) => {
            debugger
            // modal is the dismissed modal, so do what you want with it
            console.log('fechando invoiceModal');
            this.invoiceId = null
            this.update(null)
            $('body').removeClass('sidebar-mini');
        });
        this.ngxSmartModalService.getModal('invoiceModal').onCloseFinished.subscribe((modal: NgxSmartModalComponent) => {
            console.log('fechando invoiceModal no x');
            this.invoiceId = null
            this.update(null)
            $('body').removeClass('sidebar-mini');

        });
    }

    ngOnChanges() {
        if (this.invoiceId != null) {
            console.log('invoice: ' + this.invoiceId)
            this.editInvoice(this.invoiceId)
        }
    }

    editInvoice(invoiceId) {
        var obj = this
        this.dashboardService.getAdminStatement(invoiceId).subscribe(data => {
            if (data) {
                console.log('editando fatura: ' + data.code)
                console.log(data)
                obj.invoice = data
                obj.PlanItemViewerKey = obj.invoice.storeSeoName
                if (this.invoice.invoiceType == 0)
                    obj.invoiceTypeEdit = "iugu"
                if (this.invoice.invoiceType == 1)
                    obj.invoiceTypeEdit = "safe2pay"
                if (this.invoice.invoiceType == 5)
                    obj.invoiceTypeEdit = "juno"

                if (obj.invoice.paymentList == null) {
                    obj.invoice.paymentList = []
                }
                setTimeout(() => {
                    obj.ngxSmartModalService.getModal('invoiceModal').open()
                }, 200);

                $('body').addClass('sidebar-mini');
            } else {
                this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro durante a busca pela fatura')
            }
        })
    }

    update(model: CampaignCouponModel) {
        debugger
        var invoiceModel = this.invoice;
        this.answer.emit({
            "invoiceEdit": invoiceModel
        });

    }


    AddRemoveSubItem(type, invoice: StoreStatement) {
        debugger
        if (type == "plus") {
            var subitem = new InvoiceSubItens()
            subitem.description = 'adicione descrição'
            subitem.value = 0

            if (this.invoice.subItens == null)
                this.invoice.subItens = []
            else
                this.invoice.subItens.push(subitem)

            this.invoice.subItens = this.invoice.subItens;
        }
        else {
            this.invoice.subItens.pop()
            this.invoice.subItens = this.invoice.subItens;
        }
    }

    trackSubItemById(index: number, item: InvoiceSubItens) {
        return index
    }


    updateSubItens() {
        debugger
        this.dashboardService.updatePolenSubItens(this.invoice).subscribe(data => {
            if (data) {
                this.statementEdit = data
                this.notificationBuilder.showNotification('success', 1000, 'SubItem alterada com sucesso!')
            } else {
                this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro durante a busca pela fatura')
            }
        })
    }


    updatePlan(invoice: StoreStatement) {
        debugger
        this.dashboardService.updatePlan(invoice).subscribe(data => {
            if (data) {
                this.statementEdit = data
                this.notificationBuilder.showNotification('success', 1000, 'Plano alterada com sucesso!')
            } else {
                this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro durante a busca pela fatura')
            }
        })
    }

    onPaymentListChange(option, event) {
        debugger
        if (event.target.checked) {
            this.invoice.paymentList.push(option.id);
        } else {
            for (var i = 0; i < this.fixPaymentList.length; i++) {
                if (this.invoice.paymentList[i] == option.id) {
                    this.invoice.paymentList.splice(i, 1);
                }
            }
        }
        console.log(this.invoice.paymentList);
    }

    updatePaymentList(invoice: StoreStatement) {
        debugger
        this.dashboardService.updatePaymentList(invoice).subscribe(data => {
            if (data) {
                this.statementEdit = data
                this.notificationBuilder.showNotification('success', 1000, 'Métodos de Pagamento alterada com sucesso!')
            } else {
                this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro durante a busca pela fatura')
            }
        })
    }


    updatePolenSubscription(invoice: StoreStatement) {
        debugger
        this.dashboardService.updatePolenSubscription(invoice).subscribe(data => {
            if (data) {
                this.statementEdit = data
                this.notificationBuilder.showNotification('success', 1000, 'Fatura alterada com sucesso!')
            } else {
                this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro durante a busca pela fatura')
            }
        })
    }



    updateStatementDate(invoice: StoreStatement) {
        debugger
        this.dashboardService.updateStatementDate(invoice).subscribe(data => {
            if (data) {
                this.statementEdit = data
                this.notificationBuilder.showNotification('success', 1000, 'Data alterada com sucesso!')
            } else {
                this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro durante a busca pela data')
            }
        })
    }

    updateStatementInvoiceDate(invoice: StoreStatement) {
        debugger
        this.dashboardService.updateStatementInvoiceDate(invoice).subscribe(data => {
            if (data) {
                this.statementEdit = data
                this.notificationBuilder.showNotification('success', 1000, 'Data alterada com sucesso!')
            } else {
                this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro durante a busca pela data')
            }
        })
    }

    updateStatementInvoice(invoice: StoreStatement) {
        debugger
        if ((invoice.statusStatement == 2 || invoice.statusStatement == 4) && invoice.paymentAvailableDate == null) {
            this.notificationBuilder.showNotification('danger', 1000, 'Para alterar para pago/doado é necessário informar quando o valor estará disponível pelo banco.');
            return false;
        }

        this.dashboardService.updateStatementInvoice(invoice).subscribe(data => {
            if (data) {
                this.statementEdit = data
                this.notificationBuilder.showNotification('success', 1000, 'Fatura alterada com sucesso!')
            } else {
                this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro durante a busca pela fatura')
            }
        })
    }

    cancelInvoice(invoice: StoreStatement) {
        var texto = "Só é possível cancelar fatura NÃO PAGA \n" +
            "Se estiver Pago e for via Car†ão, vamos Estornar!  \n" +
            "Se for estornar e passou de 24h da cobrança, pagamos multa na Juno!!! 😡  \n" +
            "Deseja Cancelar ou Estornar a Invoice?"
        swal({
            type: 'warning',
            title: 'ATENÇÃO',
            html: '<pre>' + texto + '</pre>',
            icon: 'question',
            confirmButtonText: 'Cancelar/Estornar',
            cancelButtonText: 'Deixa quieto',
            reverseButtons: true
        }).then((result) => {
            if (result) {
                debugger
                this.junoService.cancelOrRefund(invoice.id).subscribe(data => {
                    if (data != null && data.success) {
                        this.notificationBuilder.showNotification('success', 1000, 'Fatura na Juno cancelada com sucesso!')
                    } else {
                        this.notificationBuilder.showNotification('danger', 4000, data.error)
                    }
                    //window.location.reload()
                })
            }
        })
    }


    chooseCreateInvoiceFromStatement(invoice: StoreStatement) {
        debugger
        var obj = this;

        if ((invoice.invoiceId == null || invoice.invoiceId == '') && invoice.statusStatement == 1) {
            swal({
                title: "Qual meio de pagamento?",
                text: "digite: juno ou iugu",
                input: 'text',
                showCancelButton: true
            }).then((result) => {
                debugger
                var paymentType = -1
                if (result == 'juno') {
                    paymentType = 5
                }
                if (result == 'iugu') {
                    paymentType = 0
                }
                if (paymentType >= 0) {
                    swal({
                        icon: 'info',
                        title: "Realizar Pagamento?",
                        text: "Se tiver cartão cadastrado, criar fatura e também pagar com cartão?",
                        showCloseButton: true,
                        showCancelButton: true,
                        focusConfirm: false,
                        cancelButtonText:
                            '<i class="far fa-credit-card"></i> Sim, pagar!',
                        confirmButtonText:
                            '<i class="fas fa-file-invoice"></i> Apenas Fatura'
                    }).then((result2) => {
                        debugger
                        console.log('só gera a fatura sem pagamento')
                        obj.createInvoiceFromStatement(invoice, paymentType, false);
                    }, function (dismiss2) {
                        debugger
                        if (dismiss2 === 'cancel') {
                            console.log('faz com pagamento')
                            obj.createInvoiceFromStatement(invoice, paymentType, true);
                        }
                    });
                }
                else {
                    obj.notificationBuilder.showNotification('danger', 1000, 'não entendi o que você quer da vida...')
                }
    
            }, function (dismiss) {
                if (dismiss === 'cancel') {
                }
            });
        }
        else{
            var texto = "Para gerar a 2º via das faturas: \n" +
            "1. Apague o campo Id da Invoice \n" +
            "2. Apague o campo Link da Invoice \n" +
            "3. Altere o status da fatura para AGUARDANDO PAGAMENTO \n" +
            "4. Clique em ATUALIZAR FATURA \n" +
            "5. Caso tenha outras faturas passadas que quer juntar, faça o mesmo com as antigas. \n" +
            "5.1 Ao gerar a 2º via desta fatura, as outras do passado irão ser juntadas na mesma invoice. \n" +
            "5. Pronto, agora você pode gerar a 2º via!!!";
            swal({
                type: 'warning',
                title: 'Ops, corrija os itens abaixo p/ 2º via',
                html: '<pre>' + texto + '</pre>',
                icon: 'question',
                confirmButtonText: 'Ok, vou corrigir',
                cancelButtonText: 'Deixa quieto',
                reverseButtons: true
            }).then((result) => {
               
            })
        }

        
    }

    createInvoiceFromStatement(invoice: StoreStatement, invoiceType: number, chargeCreditCard: boolean) {
        this.dashboardService.createInvoiceStatement(invoice.id, invoiceType, chargeCreditCard).subscribe(data => {
            if (data != null && data.success) {
                this.notificationBuilder.showNotification('success', 1000, 'Fatura na Iugu criada com sucesso!')
            } else {
                this.notificationBuilder.showNotification('danger', 1000, data.error)
            }
            //window.location.reload()
        })
    }
    
    updateNotaFiscal(invoice: StoreStatement) {
        debugger
        this.dashboardService.adminUpdateNotaFiscal(invoice).subscribe(data => {
            if (data) {
                this.statementEdit = data
                this.notificationBuilder.showNotification('success', 1000, 'NF alterada com sucesso!')
            } else {
                this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro durante a busca pela fatura')
            }
        })
    }

    updateDonationValue(invoice: StoreStatement, ngo: any) {
        debugger
        if (ngo.newDescription == "") {
            this.notificationBuilder.showNotification('danger', 1000, 'Mas bah, descreva pq você está alterando essa doação')
            return;
        }

        if (ngo.newDonationValue == 0) {
            this.notificationBuilder.showNotification('danger', 1000, 'doação não pode ser zero')
            return;
        }

        if (ngo.newDonationValue != ngo.donation) {
            var obj = this
            this.dashboardService.adminUpdateDonationFromStatement(invoice.id, ngo.commissionSaleId, ngo.newDonationValue, ngo.newDescription).subscribe(data => {
                if (data.success) {
                    this.notificationBuilder.showNotification('success', 1000, 'Valor da doação e fatura atualizada de ' + ngo.donation + ' para ' + ngo.newDonationValue + '!')
                    setTimeout(() => {
                        obj.ngxSmartModalService.getModal('invoiceModal').close()
                    }, 200);
                } else {
                    this.notificationBuilder.showNotification('danger', 1000, 'ocorreu o erro ' + data.error)
                }
            })
        }
        else {
            this.notificationBuilder.showNotification('success', 1000, 'Valor é o mesmo, sem modificações')
        }

    }


    editStore() {
        debugger
        this.dashboardService.getAdminStore(this.invoice.storeId).subscribe(data => {
            this.authenticationService.Impersonate(data.email, '#/profile/invoices')
        });

    }

    openInvoice(invoice: StoreStatement) {
        if (invoice.invoiceType == 5) {
            var win = window.open(Configuration.InvoiceUrl(invoice.id), '_blank');
            win.focus();
        }
        else {
            var win = window.open(invoice.invoiceUrl, '_blank');
            win.focus();
        }
    }
}
